import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div<{ itemsPerRow: number }>`
  display: flex;
  flex-wrap: wrap;

  & > * {
    flex: 1 0 ${props => 100 / props.itemsPerRow}%;
    ${media.lessThan('sm')`
      flex: 1 0 100%;
    `};
  }
`;
